<template>
    <eg-button
        :variant="isChecked ? 'eg-light-blue' : 'eg-dark-blue'"
        :class="[isChecked ? 'btn-checkbox--activated' : '']"
        style="height: 100%"
        :disabled="disabled"
    >
        <div class="btn-checkbox__container">
            <div class="btn-checkbox-square">
                <i class="material-icons" v-if="isChecked">checked</i>
            </div>
            <slot />
        </div>
    </eg-button>
</template>

<script>
export default {
    name: 'ButtonCheckbox',
    props: {
        checked: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        isChecked() {
            return this.checked;
        },
    },
};
</script>

<style lang="scss">
.btn-checkbox {
    &--activated {
        background: #dff0fa !important;
        padding: 6px 30px !important;
    }

    &__container {
        text-transform: uppercase;
        display: flex;
        flex-direction: row;
        max-height: 30px important;
        font-size: 12px;

        justify-content: center;
    }

    &-square {
        max-width: 16px;
        height: 16px;
        margin-right: 7px;
        background: white;
        position: relative;
        font-size: 13px;
        width: 100%;
        border: 1px solid #0e53a5;
        border-radius: 3px;

        & i {
            position: static;
            color: #707070;
            font-size: 16px;
        }
    }

    &--disabled {
        background-color: #dbdbdb !important;
        color: #707070 !important;
    }
}
</style>
